import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AiFillCaretLeft, AiFillCaretRight, AiFillCaretDown } from "react-icons/ai";
import PercentageBar from '../PercentageBar';
import "../../Styles/HomeMap.css";
import { SideController } from "./SideController";
import Legend from "./Legend";
import Sidebar from "../Sidebar";
import Chart from "./Chart";
import ReligionPageSide from "../ReligionPageSide";
import mapboxgl from 'mapbox-gl';
import { world_religion } from "./WorldReligion";
import { Centroid } from "../../Centroid";
import Collapsible from "react-collapsible";


mapboxgl.accessToken = 'pk.eyJ1IjoiZWRtYW4iLCJhIjoiY2syNWs1ajk3MGM2NjNua3gxYTNhdWpkOSJ9.ngu-SlVjhLdLBPyDFFsIBw';

const ChristianityPage = () => {
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [lng, setLng] = useState(-70.9);
    const [lat, setLat] = useState(42.35);
    const [zoom, setZoom] = useState(1);
    const [firstReligion, setFirstReligion] = useState("...");
    const [secondReligion, setSecondReligion] = useState("...");
    const [province, setProvince] = useState("...");
    const [country, setCountry] = useState("...");
    const [numerical, setNumerical] = useState(null);
    const [numeric_1, setNumeric_1] = useState(null);
    const [year, setYear] = useState("...");
    const [dataSource, setDataSource] = useState("...");
    const [dataURL, setDataURL] = useState("...");
    const [sideFeatures, setSideFeatures] = useState([]);

    var c = "";

    useEffect(() => {
        if (map.current) return; // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/light-v10',
            center: [lng, lat],
            zoom: zoom,
            maxZoom: 5,
            renderWorldCopies: false,
        });
        map.current.addControl(new mapboxgl.NavigationControl());
    }, []);

    useEffect(() => {
        map.current.on('load', () => {
            map.current.addSource('world_religion', {
                'type': 'vector',
                'url': 'mapbox://edman.BRI_Religion_JSON2'
            });
            map.current.addLayer(world_religion, 'state-label');
            map.current.addLayer({
                'id': 'state-fills',
                'type': 'fill',
                'source': 'world_religion',
                'source-layer': 'BRI_Religion_JSON2',
                'layout': {},
                'paint': {'fill-color': 'transparent','fill-outline-color':'black','fill-opacity': ['case',['boolean', ['feature-state', 'click'], false],1,0]}
                }
            );
            map.current.addLayer({
                'id': 'hover-fills',
                'type': 'line',
                'source': 'world_religion',
                'source-layer': 'BRI_Religion_JSON2',
                'layout': {},
                'paint': {'line-width': 1}
                },'state-label'
            );
            map.current.setLayoutProperty("settlement-subdivision-label", 'visibility', 'none');
            
            
            
        });

        map.current.on('mousemove', 'state-fills', (e) => {
            map.current.setFilter("hover-fills", [
                "any",
                ["==", "ProvName", e.features[0].properties.ProvName],
              ]);
            setFirstReligion(e.features[0].properties.HighRelig);
            setSecondReligion(e.features[0].properties.SecRelig);
            setProvince(e.features[0].properties.ProvName);
            setCountry(e.features[0].properties.Country);
            setNumerical(e.features[0].properties.Numerical);
            setNumeric_1(e.features[0].properties.Nummeric_1);
            setYear(e.features[0].properties.Year);
            setDataSource(e.features[0].properties.DataSource);
            setDataURL(e.features[0].properties.DataURL);
            
        });
        map.current.on('click', 'hover-fills', (e) => {
            map.current.setFilter("hover-fills", [
                "any",
                ["==", "ProvName", e.features[0].properties.ProvName],
              ]);
            setFirstReligion(e.features[0].properties.HighRelig);
            setSecondReligion(e.features[0].properties.SecRelig);
            setProvince(e.features[0].properties.ProvName);
            setCountry(e.features[0].properties.Country);
            setNumerical(e.features[0].properties.Numerical);
            setNumeric_1(e.features[0].properties.Nummeric_1);
            setYear(e.features[0].properties.Year);
            setDataSource(e.features[0].properties.DataSource);
            setDataURL(e.features[0].properties.DataURL);
            
        });
        map.current.on('mouseleave', 'state-fills', () => {
            map.current.setFilter("hover-fills", false);
        });

        map.current.on('load', () => {
          map.current.setFilter("world_religion", f);
          map.current.setFilter("state-fills", f);
          map.current.setFilter("hover-fills", false);
          map.current.flyTo({
            center: [80, 30],
            zoom: 2.5,
          });
          
          SideController(map);
          document.getElementById("rotationRE").onclick= resetRfun;
          document.getElementById("tiltRE").onclick= resetTfun;
          document.getElementById("rotationsliderinput").oninput= barRotate;
          document.getElementById("tiltsliderinput").oninput= barTilt;

        })

        map.current.on('zoom', () => {
          var zlevel = parseInt(map.current.getZoom());
          document.getElementById('zoomextent').innerHTML=zlevel;
          });

        map.current.on('rotate', function () {
          document.getElementById('rotationslidercurrent').innerHTML='Rotate: ' + map.current.getBearing().toFixed(1) + '&#xb0;'
          document.getElementById('rotationslider').style.display = 'unset';
          // document.getElementById('rotationsliderinput').getAttribute("value").value(map.current.getBearing().toFixed(1))
        });

        map.current.on('pitch', function () {
          document.getElementById('tiltslidercurrent').innerHTML='Tilt: ' + map.current.getPitch().toFixed(1) + '&#xb0;'
          document.getElementById('tiltslider').style.display = 'unset';
          // document.getElementById('rotationsliderinput').getAttribute("value").value(map.current.getBearing().toFixed(1))
        });

        
        
        
        map.current.on('moveend', () => {
          if(render==false){
              setSideFeatures(map.current.queryRenderedFeatures({layers: ['world_religion']}))
              render=true;
            }
          });
          c="";
    }, []);

    var render = false;
    const [f,setF] = useState([
      "any",
      ["==", "HighRelig", "Protestants"],
      ["==", "HighRelig", "Eastern orthodox"],
      ["==", "HighRelig", "Catholics"],
      ["==", "HighRelig", "Oriental"],
      ["==", "HighRelig", "Mormon"],
    ]);
    
    function chartMouseOver(feature){
      setFirstReligion(feature.properties.HighRelig);
      setSecondReligion(feature.properties.SecRelig);
      setProvince(feature.properties.ProvName);
      setCountry(feature.properties.Country);
      setNumerical(feature.properties.Numerical);
      setYear(feature.properties.Year);
      setDataSource(feature.properties.DataSource);
      setDataURL(feature.properties.DataURL);
      map.current.setFilter("hover-fills", ["all",["==", "Country", feature.properties.Country],["==", "ProvName", feature.properties.ProvName],]);
    }

    function chartClick(feature){
      var a = Centroid.find(e=>e.ProvName==feature.properties.ProvName);
      map.current.flyTo({
        center: [a.X, a.Y],
        zoom: a.zoomlevel}
      );
      map.current.setFilter("hover-fills", ["all",["==", "Country", feature.properties.Country],["==", "ProvName", feature.properties.ProvName],]);
    }

    function resetRfun() {map.current.rotateTo(0)}
    function resetTfun(){map.current.setPitch(0)}
    function barRotate(){var v = document.getElementById('rotationsliderinput').value;map.current.rotateTo(v);}
    function barTilt(){var v = document.getElementById('tiltsliderinput').value;map.current.setPitch(v);}

    const [protestantsOn,setProtestantsOn] = useState(true);
    const [orthodoxOn,setOrthodoxOn] = useState(true);
    const [catholicsOn,setCatholicsOn] = useState(true);
    const [orientalOn,setOrientalOn] = useState(true);
    const [mormonOn,setMormonOn] = useState(true);

    function toggleSubreligion(religion){
      var a;
      if(religion=="Protestants"){a=protestantsOn;}
      if(religion=="Eastern orthodox"){a=orthodoxOn;}
      if(religion=="Catholics"){a=catholicsOn;}
      if(religion=="Oriental"){a=orientalOn;}
      if(religion=="Mormon"){a=mormonOn;}

      if(a){
        var f2 = f.filter(e => e[2] !== religion)
        map.current.setFilter("world_religion", f2);
        setF(f2);
      }
      else{
        var b = ["==", "HighRelig"];
        b.push(religion);
        var f3 = f.concat([b]);
        map.current.setFilter("world_religion", f3);
        setF(f3);
      }
      window.setTimeout(( () => 
        {const features = map.current.queryRenderedFeatures({layers: ['world_religion']});
      if (features) {setSideFeatures(features);c="";}}
      ), 100);
      
    }

    const [cityOn, setCityOn] = useState(true);
    const [stateOn, setStateOn] = useState(true);
    const [countryBOn, setCountryBOn] = useState(true);
    const [provinceBOn, setProvinceBOn] = useState(true);
    function toggleCity(){
      if(cityOn){map.current.setLayoutProperty("settlement-label", 'visibility', 'none');}
      else{map.current.setLayoutProperty("settlement-label", 'visibility', 'visible');}
      setCityOn(!cityOn);
    }
    function toggleState(){
      if(stateOn){map.current.setLayoutProperty("state-label", 'visibility', 'none');}
      else{map.current.setLayoutProperty("state-label", 'visibility', 'visible');}
      setStateOn(!stateOn);
    }
    function toggleCountryB(){
      if(countryBOn){map.current.setLayoutProperty("admin-0-boundary", 'visibility', 'none');map.current.setLayoutProperty("admin-0-boundary-bg", 'visibility', 'none');}
      else{map.current.setLayoutProperty("admin-0-boundary", 'visibility', 'visible');map.current.setLayoutProperty("admin-0-boundary-bg", 'visibility', 'visible');}
      setCountryBOn(!countryBOn);
    }
    function toggleProvinceB(){
      if(provinceBOn){map.current.setLayoutProperty("admin-1-boundary", 'visibility', 'none');map.current.setLayoutProperty("admin-1-boundary-bg", 'visibility', 'none');map.current.setLayoutProperty("state-label", 'visibility', 'none');}
      else{map.current.setLayoutProperty("admin-1-boundary", 'visibility', 'visible');map.current.setLayoutProperty("admin-1-boundary-bg", 'visibility', 'visible');}
      setProvinceBOn(!provinceBOn);
    }
    
    const [sideMode, setSideMode] = useState("intro");

    function ascend(x,y){return ((x.properties.Numerical==y.properties.Numerical)?0:((x.properties.Numerical>y.properties.Numerical)?1:-1));}
    function descend(x,y){return ((x.properties.Numerical==y.properties.Numerical)?0:((x.properties.Numerical<y.properties.Numerical)?1:-1));}
    function byCountry(x,y){return ((x.properties.Country==y.properties.Country)?0:((x.properties.Country>y.properties.Country)?1:-1));}


    return (
        <div className="homeMap">
            <Link to="/" style={{fontSize:"3vh",lineHeight:"5vh",textDecoration:"none", position:"absolute", top:"2vh",left:"10px", color:"#DDDDDD"}}>
                <div className="backButton"> <AiFillCaretLeft size={28} style={{verticalAlign:"bottom"}}/>Full Map Mode</div>
            </Link>
            <div className="religionPageList">
                <div style={{width:"33vw"}}>
                  <div style={{backgroundColor:"#4673D2"}}>The Christianity World</div>
                </div>
                <div onClick={()=>{toggleSubreligion("Protestants");setProtestantsOn(!protestantsOn);}}
                style={protestantsOn?{background:"transparent linear-gradient(270deg, #C0CFEE 0%, #849FDE 40%, #4872CE 60%, #2F58B5 100%) 0% 0%",width:"13.2vw"}:{background:"lightgrey",width:"13.2vw"}}>
                  Protestants
                </div>
                <div onClick={()=>{toggleSubreligion("Eastern orthodox");setOrthodoxOn(!orthodoxOn);}} 
                style={orthodoxOn?{background:"transparent linear-gradient(270deg, #C0CFEE 0%, #A1A1C1 40%, #7373A2 60%, #50507B 100%) 0% 0%", width:"13.2vw"}:{background:"lightgrey", width:"13.2vw"}}>
                  Eastern Orthodox
                </div>
                <div onClick={()=>{toggleSubreligion("Catholics");setCatholicsOn(!catholicsOn);}} 
                style={catholicsOn?{background:"transparent linear-gradient(270deg, #D8B2FC 0%, #A54DFB 40%, #7400E1 60%, #40007E 100%) 0% 0%", width:"13.2vw"}:{background:"lightgrey", width:"13.2vw"}}>
                  Catholics
                </div>
                <div onClick={()=>{toggleSubreligion("Oriental");setOrientalOn(!orientalOn);}} 
                style={orientalOn?{background:"transparent linear-gradient(270deg, #CBCBFC 0%, #4F4BFA 40%, #0A00C8 60%, #03007E 100%) 0% 0%", width:"13.2vw"}:{background:"lightgrey", width:"13.2vw"}}>
                  Oriental
                </div>
                <div onClick={()=>{toggleSubreligion("Mormon");setMormonOn(!mormonOn);}} 
                style={mormonOn?{background:"transparent linear-gradient(270deg, #E5E5E5 0%, #BEBEBE 40%, #989898 60%, #737373 100%) 0% 0%", width:"13.2vw"}:{background:"lightgrey", width:"13.2vw"}}>
                  Mormon
                </div>
            </div>
            <div className="religionMapMain">
                <div className="religionPageSide">
                  <div className="religionPageSideButtons" style={{display:"flex", backgroundColor:"#CECECE", position:"sticky", height:"5%"}}>
                    <button onClick={()=>setSideMode("intro")}>intro</button>
                    <button onClick={()=>setSideMode("by country")}>by country</button>
                    <button onClick={()=>setSideMode("ascending")}>ascending</button>
                    <button onClick={()=>setSideMode("descending")}>descending</button>
                  </div>
                  
                  {sideMode=="intro"&&<ReligionPageSide religion="Buddhism" country={country} province={province} firstReligion={firstReligion} numerical={numerical} secondReligion={secondReligion}
                  numeric_1={numeric_1} year={year} dataSource={dataSource} dataURL={dataURL}/>}
                  {sideMode=="by country"&&
                  <>
                    <div className="sideContent">
                    {sideFeatures.sort(byCountry).map(
                      function(feature) {
                        if(c=="" || c!=feature.properties.Country){
                          c = feature.properties.Country;
                          return(
                          <Collapsible trigger={<><AiFillCaretRight/>{c}</>}
                          triggerWhenOpen={<><AiFillCaretDown/>{c}</>}>
                            {
                              sideFeatures.filter(feature=>feature.properties.Country==c).map(feature=>
                                <>
                                <div className="sideBlock" onMouseOver={() => chartMouseOver(feature)}
                                    onMouseLeave={() => {map.current.setFilter("hover-fills", false);}}
                                    onClick = {() => chartClick(feature)}
                                      >
                                  {feature.properties.ProvName}
                                </div> 
                                <PercentageBar percent1={feature.properties.Numerical} religion1={feature.properties.HighRelig}
                                percent2={feature.properties.Nummeric_1} religion2={feature.properties.SecRelig}/>
                                </>
                              )
                            }

                          </Collapsible>
                          )
                          
                        }  
                      }
                    )}
                    </div>
                    <div className="note" style={{height:"20%", fontSize:"xsmall", backgroundColor:"lightgrey"}}>
                      Note<br/>
                      Dominant Religion:{firstReligion}<br/>
                      Data Source:<br/>{dataSource}
                    </div>
                  </>
                  }
                  {sideMode=="ascending"&&
                    <>
                    <div className="sideContent">
                    {sideFeatures.sort(ascend).map(feature=>
                            <>
                              <div className="sideBlock" onMouseOver={() => chartMouseOver(feature)}
                                  onMouseLeave={() => {map.current.setFilter("hover-fills", false);}}
                                  onClick = {() => chartClick(feature)}
                                    >
                                {feature.properties.Country+"-"+feature.properties.ProvName}
                              </div> 
                              <PercentageBar percent1={feature.properties.Numerical} religion1={feature.properties.HighRelig}/>
                            </>
                    
                    )}
                    </div>
                    <div className="note" style={{height:"20%", fontSize:"xsmall", backgroundColor:"lightgrey"}}>
                    Note<br/>
                    Dominant Religion:{firstReligion}<br/>
                    Data Source:<br/>{dataSource}
                  </div>
                    </>
                  }       
                  {sideMode=="descending"&&
                  <>
                    <div className="sideContent">
                    {sideFeatures.sort(descend).map(feature=>
                            <>
                              <div className="sideBlock" onMouseOver={() => chartMouseOver(feature)}
                                  onMouseLeave={() => {map.current.setFilter("hover-fills", false);}}
                                  onClick = {() => chartClick(feature)}
                                    >
                                {feature.properties.Country+"-"+feature.properties.ProvName}
                              </div> 
                              <PercentageBar percent1={feature.properties.Numerical} religion1={feature.properties.HighRelig}/>
                            </>
                    )}
                    </div>
                    <div className="note" style={{height:"20%", fontSize:"xsmall", backgroundColor:"lightgrey"}}>
                      Note<br/>
                      Dominant Religion:{firstReligion}<br/>
                      Data Source:<br/>{dataSource}
                    </div>
                  </>
                  }      
                </div>

                <div ref={mapContainer} className="religion-map-container" />
                
            </div>
            
            <div className="bottomBar">
              <AiFillCaretRight style={{verticalAlign:"bottom"}}/>Customization of the map view
              <button onClick={()=>toggleCity()}>City</button>
              <button onClick={()=>toggleState()}>State</button>
              <button onClick={()=>toggleCountryB()}>CountryB</button>
              <button onClick={()=>toggleProvinceB()}>ProvinceB</button>
            </div>
        </div>
    );
};

export default ChristianityPage;


// ["==", "HighRelig", "Protestants"],
// ["==", "HighRelig", "Eastern orthodox"],
// ["==", "HighRelig", "Catholics"],
// ["==", "HighRelig", "Oriental"],
// ["==", "HighRelig", "Mormon"],